<template>
    <LoadingComponent :props="loading" />
    <div class="col-12">
        <div class="db-card">
            <div class="db-card-header flex items-center justify-between">
                <h3 class="font-medium text-lg capitalize text-heading">{{ $t('menu.top_products') }}</h3>
                <div v-if="products.length > 0" class="flex items-center gap-2">
                    <button type="button" class="top-products-prev w-8 h-8 rounded-full border flex items-center justify-center bg-white hover:bg-primary hover:text-white text-heading transition-all shadow-2xs">
                        <i class="lab-line-chevron-left text-sm"></i>
                    </button>
                    <button type="button" class="top-products-next w-8 h-8 rounded-full border flex items-center justify-center bg-white hover:bg-primary hover:text-white text-heading transition-all shadow-2xs">
                        <i class="lab-line-chevron-right text-sm"></i>
                    </button>
                </div>
            </div>
            <div class="db-card-body">
                <div v-if="products.length > 0" class="relative">
                    <Swiper dir="ltr"
                        :speed="500"
                        :slidesPerGroup="1"
                        :navigation="{ prevEl: '.top-products-prev', nextEl: '.top-products-next' }"
                        :modules="modules"
                        :breakpoints="breakpoints"
                        class="top-products-swiper">
                        <SwiperSlide v-for="product in products" :key="product.id" class="h-auto">
                            <div class="sm:p-2 rounded-2xl border transition-all duration-300 group h-full bg-white flex flex-col justify-between">
                                <div class="relative overflow-hidden rounded-xl isolate">
                                    <label v-if="product.is_offer && product.flash_sale"
                                        class="capitalize text-xs font-semibold rounded-xl py-1 px-2 shadow-badge absolute top-3 left-3 z-10 bg-danger text-white">
                                        {{ $t('label.flash_sale') }}
                                    </label>

                                    <img :src="product.cover" alt="product"
                                        class="w-full rounded-xl transition-all duration-300 group-hover:scale-105 group-hover:rotate-3">
                                </div>

                                <div class="px-2 sm:px-2 pt-4 pb-2 flex-1 flex flex-col justify-between">
                                    <div>
                                        <h3 class="capitalize text-base font-semibold whitespace-nowrap mb-1.5 transition-all duration-300 hover:text-primary overflow-hidden text-ellipsis" :title="product.name">
                                            {{ product.name }}
                                        </h3>

                                        <div class="flex flex-wrap items-center gap-2 mb-4">
                                            <div class="flex items-center gap-1">
                                                <starRating border-color="#FFBC1F" :rounded-corners="true" :padding="2.5" :border-width="2.5"
                                                    :star-size="9" class="mt-[2px]" inactive-color="#FFFFFF" active-color="#FFBC1F"
                                                    :round-start-rating="false" :show-rating="false" :read-only="true" :max-rating="5"
                                                    :rating="(product.rating_star / (product.rating_star_count || 1))" />
                                            </div>
                                            <div v-if="product.rating_star_count > 0" class="flex items-center gap-1 mt-[5px]">
                                                <span class="text-xs font-medium whitespace-nowrap text-text">
                                                    {{ (product.rating_star / product.rating_star_count).toFixed(1) }}
                                                </span>
                                                <span class="text-xs font-medium whitespace-nowrap text-text hover:text-primary">
                                                    ({{ product.rating_star_count }} {{ product.rating_star_count > 1 ? $t('label.reviews') : $t('label.review') }})
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex flex-wrap-reverse items-center border-t pt-3 gap-x-3 gap-y-1" v-if="product.is_offer">
                                        <h3 class="text-xl sm:text-[22px] font-bold">
                                            <span class="text-danger">{{ product.discounted_price }}</span>
                                        </h3>
                                        <h4 class="text-sm sm:text-base font-semibold text-text font-title">
                                            <del>{{ product.currency_price }}</del>
                                        </h4>
                                    </div>
                                    <div v-else class="w-full border-t pt-3">
                                        <h4 class="text-xl sm:text-[22px] font-bold">
                                            <span>{{ product.currency_price }}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../components/LoadingComponent";
import starRating from "vue-star-rating";
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';

export default {
    name: "TopProductsComponent",
    components: { LoadingComponent, starRating, Swiper, SwiperSlide },
    setup() {
        return {
            modules: [Navigation],
        }
    },
    data() {
        return {
            loading: {
                isActive: false,
            },
            breakpoints: {
                0: { slidesPerView: 2, spaceBetween: 16 },
                560: { slidesPerView: 3, spaceBetween: 20 },
                768: { slidesPerView: 4, spaceBetween: 20 },
                1280: { slidesPerView: 5, spaceBetween: 24 }
            }
        };
    },
    mounted() {
        this.topProducts();
    },
    computed: {
        products: function () {
            return this.$store.getters["dashboard/topProducts"];
        }
    },
    methods: {
        topProducts: function () {
            this.loading.isActive = true;
            this.$store.dispatch('dashboard/topProducts').then(res => {
                this.loading.isActive = false;
            }).catch((err) => {
                this.loading.isActive = false;
            });
        },
    },
}
</script>
